// extracted by mini-css-extract-plugin
export default {"center":"Container_center__XfgLN","column":"Container_column__8o4Kw","padd":"Container_padd__zwwO0","thumbsHome-gal":"Container_thumbsHome-gal__Moodp"};